// extracted by mini-css-extract-plugin
module.exports = {"add":"_1X1Le","primary":"_1kCQ4","secondary":"_2gM7w","darkGrey":"_3LSAg","loading":"_1xc52"};